import { render, staticRenderFns } from "./bindCard.vue?vue&type=template&id=9700b8fc&scoped=true&"
import script from "./bindCard.vue?vue&type=script&lang=js&"
export * from "./bindCard.vue?vue&type=script&lang=js&"
import style0 from "./bindCard.vue?vue&type=style&index=0&id=9700b8fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9700b8fc",
  null
  
)

export default component.exports